import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/addition/addition_template.png'
import _imports_1 from '@/assets/image/addition/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-703c0c72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "adt-template" }
const _hoisted_2 = { class: "adt-template-title rel" }
const _hoisted_3 = { class: "adt-template-title-t" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-chuangjian1" }, null, -1))
const _hoisted_5 = { class: "add-text" }
const _hoisted_6 = { class: "adt-template-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "more-bg" }, null, -1))
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "template-icon"
}, null, -1))
const _hoisted_13 = { style: {"max-width":"200px"} }
const _hoisted_14 = {
  key: 1,
  class: "empty"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "empty-text" }

import { ref, computed, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { getCustomerAdditionListApi, getAdditionTemplateDetailApi } from '@/apis/addition'
import { useRouter } from 'vue-router'
import { getWarehouseCode, isD2C, useRtfix, useSite, useUser } from '@/store'
import { useStore } from 'vuex'
import { COUNTRY } from '@/global'
import { sourceCountryInfo } from '@/views/shopcart/country'

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'adt', 'countryCode'],
  emits: ['setdefault', 'expose'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()
const router = useRouter()
const isLogin = computed(() => store.getters.isLogin)
/**
 * type 1-商品附加项组合 2-发货附加项组合
 */
const additionList: any = ref([])



const user = useUser()

const isFree = () => user.membership?.templateLevel === 0

watch(() => props.countryCode, () => {
  getCustomerAdditionListApi({
    templateType: props.type,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseCode(props.countryCode === COUNTRY.KR)
  }).then((res: any) => {
    if (res?.success) {
      const data = isFree() ? res.data.filter((v: any) => !v.isDefault) : res.data
      additionList.value = data
    }
  })
}, {
  immediate: true
})

const chooseTemplate = async (item: any) => {
  const templateAdditionListResult = await getAdditionTemplateDetailApi({
    additionTemplateId: item.additionTemplateId
  })
  const ad = await w(templateAdditionListResult?.data?.itemInfoRespDTOList)
  emits('setdefault', ad)
}

const w = async (items: any) => {
  const adtList = await props.adt
  const adList: any = []
  items.forEach((i: any) => {
    adtList.forEach((v: any) => {
      if (i.additionId === v.additionId) {
        adList.push({
          ...v,
          ...i
        })
      }
    })
  })
  return adList
}

emits('expose', w)
const jump = () => {
  const routerUrl: any = router.resolve(useRtfix('setupShop', { query: { type: 'ShopAddition', sourceCountry: props.countryCode } }))
  window.open(routerUrl.href, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('附加项组合')), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["adt-template-title-tip", _unref(useSite)()])
      }, _toDisplayString(_unref(t)('您可以将多项附加项创建为一个组合，帮助您快速选择附加项')), 3),
      (_unref(isLogin))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "add-btn flex-center abs cursor-pt",
            onClick: jump
          }, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('添加')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (additionList.value.length > 0)
        ? (_openBlock(), _createBlock(_component_el_scrollbar, {
            key: 0,
            "wrap-class": "scroll-bar-template",
            always: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "adt-template-item",
                    onClick: ($event: any) => (chooseTemplate(item))
                  }, [
                    (item.isDefault === 1)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.additionTemplateImg,
                          alt: "",
                          class: "template-img"
                        }, null, 8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_el_tooltip, {
                            effect: "light",
                            placement: "top",
                            "popper-class": "tool-tip-no-border"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(item.templateName), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.templateName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                  ], 8, _hoisted_9))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('データなし')), 1)
          ]))
    ])
  ]))
}
}

})